const colors = {
  blue: '#2F80ED',
  blue100: '#005FFF',
  textDark: '#757575',
  white: '#fff',
  grayMedium: '#9CA6B0',
  greenMain: '#00C882',
  orange: '#F5B64D',
  yellow: '#FFDD2D',
  purple100: '#3c3c64',
  purple90: '#505074',
  purple80: '#636383',
  purple60: '#8A8AA2',
  purple40: '#B1B1C1',
  purpleTrans20: 'rgba(60, 60, 100, 0.2)',
  purpleTrans10: 'rgba(60, 60, 100, 0.1)',
  purpleTrans5: 'rgba(61, 64, 102, 0.05)',
  red: '#EB5757',
};

export const scTheme = {
  primaryColor: '#67C1D5',
  primaryColorDarker: '#67C1D5',
  secondaryColor: '#3D4066',
  backgroundPrimary: '#E0E0E0',
  fontFamily: '"Work Sans", sans-serif',
  fontFamilyBold: '"Work Sans", sans-serif',
  secondFont: "'Merriweather', serif",
  textColor: '#565A77',
  headingColor: '#312F4C',
  headingHoverColor: '#EC6657',
  formLabelColor: '#9C9C9C',
  facebookColor: '#4963A4',
  linkedinColor: '#4286E5',
  errorColor: '#D60000',
  subHeadingColor: '#312F4C',
  listBgHoverColor: '#d6e4f1',
  logoHeight: '32px',
  categoryHeaderColor: '#327ab7',
  buttonTextColor: '#ffffff',
  formBackgroundColor: '#f6f6f6',
  bp: {
    sm: '600px',
    md: '900px',
    lg: '1200px',
    xl: '1800px',
  },
  ...colors,
};
